import { render } from "./WidgetOrders.vue?vue&type=template&id=84634c20&scoped=true&ts=true"
import script from "./WidgetOrders.vue?vue&type=script&lang=ts"
export * from "./WidgetOrders.vue?vue&type=script&lang=ts"

import "./WidgetOrders.vue?vue&type=style&index=0&id=84634c20&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84634c20"]])

export default __exports__